"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATE_FILTER_OPTIONS = exports.DATE_FILTER_CATEGORIES = void 0;
var DATE_FILTER_CATEGORIES;
(function (DATE_FILTER_CATEGORIES) {
    DATE_FILTER_CATEGORIES["ALL_TIME"] = "ALL_TIME";
    DATE_FILTER_CATEGORIES["CUSTOM_DATE_RANGE"] = "CUSTOM_DATE_RANGE";
    DATE_FILTER_CATEGORIES["LAST_30_DAYS"] = "LAST_30_DAYS";
    DATE_FILTER_CATEGORIES["THIS_MONTH"] = "THIS_MONTH";
    DATE_FILTER_CATEGORIES["LAST_MONTH"] = "LAST_MONTH";
    DATE_FILTER_CATEGORIES["THIS_QUARTER"] = "THIS_QUARTER";
    DATE_FILTER_CATEGORIES["LAST_QUARTER"] = "LAST_QUARTER";
    DATE_FILTER_CATEGORIES["THIS_YEAR"] = "THIS_YEAR";
    DATE_FILTER_CATEGORIES["LAST_YEAR"] = "LAST_YEAR";
})(DATE_FILTER_CATEGORIES = exports.DATE_FILTER_CATEGORIES || (exports.DATE_FILTER_CATEGORIES = {}));
exports.DATE_FILTER_OPTIONS = [
    { label: 'All Time', value: DATE_FILTER_CATEGORIES.ALL_TIME },
    { label: 'Custom Date Range', value: DATE_FILTER_CATEGORIES.CUSTOM_DATE_RANGE },
    { label: 'Last 30 Days', value: DATE_FILTER_CATEGORIES.LAST_30_DAYS },
    { label: 'This Month', value: DATE_FILTER_CATEGORIES.THIS_MONTH },
    { label: 'Last Month', value: DATE_FILTER_CATEGORIES.LAST_MONTH },
    { label: 'This Quarter', value: DATE_FILTER_CATEGORIES.THIS_QUARTER },
    { label: 'Last Quarter', value: DATE_FILTER_CATEGORIES.LAST_QUARTER },
    { label: 'This Year', value: DATE_FILTER_CATEGORIES.THIS_YEAR },
    { label: 'Last Year', value: DATE_FILTER_CATEGORIES.LAST_YEAR },
];
